export default __webpack_public_path__ + "static/media/Mitsubishi Electric.b91d4ace.png";